import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getApplicationName = createSelector(
  [(state) => state.session.locale, (state) => state.config.applicationName],
  (locale, applicationName) => applicationName[locale]
);

export const getOAuthClientId = ({ session }) => session.oAuthClientId;

export const getRetailerId = ({ session }) => get(session, 'retailer.retailerId');

export const getLicenseId = ({ relicensing }) => get(relicensing, 'licenseForm.arwTermsVersion');

export const isSuperChainSelector = ({ session }) =>
  get(session, 'retailer.isSuperChain', false) || get(session, 'retailerDashboard.isSuperChain', false);

export const isChainHeadSelector = ({ session }) =>
  get(session, 'retailer.isChainHead', false) || get(session, 'retailerDashboard.isChainHead', false);

export const isChainSubordinateSelector = ({ session }) =>
  get(session, 'retailer.isChainSubordinate', false) || get(session, 'retailerDashboard.isChainSubordinate', false);

export const isIndependentSelector = ({ session }) =>
  get(session, 'retailer.isIndependent', false) || get(session, 'retailerDashboard.isIndependent', false);

export const isStoreProfileSelector = ({ session }) => get(session, 'retailer.isStoreProfile', false);

export const isRetailerDashboardSelector = ({ retailerDashboards }) => !!retailerDashboards.type;

const inboxMessagesSelector = (state) => state.messages.inbox;
const selectedMessagesListSelector = (state) => state.messages.selectedMessages.selectedMessagesList;

export const selectedMessageDetailsSelector = createSelector(
  [inboxMessagesSelector, selectedMessagesListSelector],
  (inbox, selectedMessagesList) => {
    if (selectedMessagesList.length === 0) return null;
    const [selectedId] = selectedMessagesList;

    return inbox.find((msg) => msg.userMessageId === selectedId);
  }
);

const activeAnnouncementsSelector = (state) => state.announcements.active;

export const isEmptyActiveAnnouncementsSelector = createSelector(
  [activeAnnouncementsSelector],
  (announcements) => announcements.length === 0
);

const firstNameSelector = (state) => state.session.firstName;
const lastNameSelector = (state) => state.session.lastName;
const MAX_WELCOME_LENGTH = 20;

export const getDisplayUserNameSelector = createSelector([firstNameSelector, lastNameSelector], (firstName, lastName) => {
  // Check if first name and last name exist
  if (!firstName || !lastName) {
    return null;
  }
  //  For those users whose first and last names together exceed limit of 20 characters, the system shall...
  if (firstName.length + lastName.length > MAX_WELCOME_LENGTH) {
    // If both first name and last name exceeds our maximum length of 20, names shall be eliminated altogether
    if (firstName.length > MAX_WELCOME_LENGTH && lastName.length > MAX_WELCOME_LENGTH) {
      return '';
    }
    // If the last name is the same length as the first name
    if (firstName.length === lastName.length) {
      return firstName;
    }
    // If the last name is 1-2 characters shorter than the first name
    if (firstName.length - lastName.length >= 1 && firstName.length - lastName.length < 3) {
      return firstName;
    }
    // Where the first name is 3+ characters longer than the last name
    if (firstName.length - lastName.length >= 3) {
      return `${firstName.charAt(0)}. ${lastName}`;
    }
    // If the last name is longer than the first name
    if (lastName.length > firstName.length) {
      return firstName;
    }
  }
  return `${firstName} ${lastName}`;
});



// WEBPACK FOOTER //
// ./src/selectors/index.js